module.exports = "/_next/static/images/8966913118c7e3963c6ad5a58321f322-missions.png.webp";